import { useTimeout } from '../utils/useTimer';

export default function useLongPress() {
  const timerLongPress = useTimeout();

  return function (callback) {
    let preventClick = false;

    function start() {
      //timeout = setTimeout(() => {
      timerLongPress.current = setTimeout(() => {
        preventClick = true;
        callback();
      }, 300);
    }

    function clear() {
      //      timeout && clearTimeout(timeout);
      timerLongPress.current && clearTimeout(timerLongPress.current);
      preventClick = false;
    }

    function clickCaptureHandler(e) {
      if (preventClick) {
        e.stopPropagation();
        preventClick = false;
      }
    }

    return {
      onMouseDown: start,
      onTouchStart: start,
      onMouseUp: clear,
      onMouseLeave: clear,
      onTouchMove: clear,
      onTouchEnd: clear,
      onClickCapture: clickCaptureHandler,
    };
  };
}
/*
Usage:

import useLongPress from './useLongPress';

export default function MyComponent(){
  const onLongPress = useLongPress();
  const buttons = ['button one', 'button two', 'button three'];

  return (
    buttons.map(text => 
      <button
        onClick={() => console.log('click still working')}
        {...onLongPress(() => console.log('long press worked for ' + text))}
      >
      {text}
      </button>
    )
  )
}
*/
